import React from 'react';
import { find, get, isEmpty, map } from 'lodash';

// local dependencies
import { TableSearchWidget } from 'ui/containers/TableSearchWidget';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { tableSearchInlineWidgetPreloader as TableSearchInlineWidgetPreloader } from 'ui/views/widgets/tableSearchInlineWidget';
import { layoutConfig } from 'config/table-configs/order-list';
import { getLabel } from 'utils/getLabel';


const memberDetailsOrdersEntityWidgetSuccess = ( props ) => {
    const orderOptions = get( props.componentData, 'data.options.orderStatus', [] );
    const getStatusLabel = ( status ) => {
        const option = find( orderOptions, candidate => candidate.name === status );
        const label = option ? getLabel( get( option, 'title', {} ) ) : null;
        return isEmpty( label ) || label === '-' ? status : label;
    };
    const mapLiveOrderItems = ( items ) => map( items, item => {
        const values = get( item, 'values', {} );
        const orderStatus = get( values, 'orderStatus' );
        const lineItems = map( get( values, 'items', [] ), lineItem => {
            const lineStatus = get( lineItem, 'values.status.orderStatus' );

            if( isEmpty( lineStatus ) ) {
                return lineItem;
            }

            return {
                ...lineItem,
                values: {
                    ...lineItem.values,
                    status: {
                        ...get( lineItem, 'values.status', {} ),
                        orderStatus: getStatusLabel( lineStatus )
                    }
                }
            };
        } );

        return {
            ...item,
            values: {
                ...values,
                ...( isEmpty( orderStatus ) ? {} : { orderStatus: getStatusLabel( orderStatus ) } ),
                items: lineItems
            }
        };
    } );

    return (
        <div className='ui-member-details-orders-entity-widget'>
            <TableSearchWidget
                layoutConfig = { layoutConfig }
                templateType = 'inline'
                tableRowViewTemplate = 'block'
                tableHeadViewTemplate = 'none'
                tableResponse = { props.componentData }
                requestPayload={ props.requestPayload }
                onActionClick={ props.onActionClick }
                liveListEnabled={ get( props.componentData, 'data.state.liveListEnabled', false ) }
                liveListUrl={ get( props.componentData, 'elements.urls.fetchLiveOrdersList', null ) }
                liveListItemMapper={ mapLiveOrderItems }
            />
        </div>
    );
};

// set display name
memberDetailsOrdersEntityWidgetSuccess.displayName = 'memberDetailsOrdersEntityWidgetSuccess';

// set default props
memberDetailsOrdersEntityWidgetSuccess.defaultProps = {};

// prop types
memberDetailsOrdersEntityWidgetSuccess.propTypes = {};

const memberDetailsOrdersEntityWidgetPreloader = ( ) => {
    return (
        <div className='ui-member-details-orders-entity-widget-preloader'>
            <TableSearchInlineWidgetPreloader
                className='ui-member-details-orders-entity-widget-preloader__table-preloader'
            />
        </div>
    );
};

// set display name
memberDetailsOrdersEntityWidgetPreloader.displayName = 'memberDetailsOrdersEntityWidgetPreloader';

// set default props
memberDetailsOrdersEntityWidgetPreloader.defaultProps = {};

// prop types
memberDetailsOrdersEntityWidgetPreloader.propTypes = {};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberDetailsOrdersEntityWidget as MemberDetailsOrdersEntityWidget } from 'ui/views/widgets/memberDetailsOrdersEntityWidget';
 *
 * // render
 * <MemberDetailsOrdersEntityWidget propName='propValue'/>
 */

export const memberDetailsOrdersEntityWidget = withNetworkState( memberDetailsOrdersEntityWidgetPreloader, memberDetailsOrdersEntityWidgetSuccess );
